<!--accessibility-->
<div id="skiptocontent" [tabIndex]="globalConfigurationService.getAddIndexToSkiptocontent()?null:1" [ngStyle]="{visibility:isAllowedSkipNavigation?'':'hidden'}"><a href="#maincontent" id="skiptocontent_link" tabindex="0" (click)="navigateToAnchor($event)">{{'generic.accessibility_goto_main' | translate}}</a></div>
<!-- PROGRESS BAR -->
<!-- <fuse-progress-bar></fuse-progress-bar> -->
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
<ng-container *ngIf="layoutConfig.layout.style === 'vertical-layout-1'">
    <vertical-layout-1 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-1>
</ng-container>
<!-- / VERTICAL LAYOUT 1 -->